export default (theme) => {
  const line = (width, style = 'solid') => `${width} ${style} ${theme.palette.common.black}`;
  const row = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    columnGap: '5mm',
    alignItems: 'baseline',
  };
  const strong = { fontWeight: 600, whiteSpace: 'nowrap' };
  const emph = { fontSize: '10.5pt', fontWeight: 600 };
  const sum = { ...row, '& $value': strong };
  const cell = { alignSelf: 'start', marginTop: '0.8mm' };
  const tag = { fontSize: '10pt', fontWeight: 400, marginLeft: '2mm' };

  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '10pt',
      fontWeight: 400,
      lineHeight: 1.35,
      color: theme.palette.common.black,
      '& *': { boxSizing: 'border-box' },
    },
    block: { breakInside: 'avoid', pageBreakInside: 'avoid' },
    head: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      borderBottom: line('1.5pt'),
      paddingBottom: '1.5mm',
      marginBottom: '5mm',
    },
    subject: {
      fontSize: '15pt',
      fontWeight: 600,
      '& span': tag,
    },
    day: { marginBottom: '8mm', border: line('1pt'), borderTop: 0 },
    bar: { ...row, borderTop: line('1pt'), padding: '1.5mm 3mm 0' },
    barTitle: { fontSize: '12pt', fontWeight: 600, '& span': tag },
    note: { fontSize: '8.5pt' },
    user: { ...row, padding: '0.8mm 3mm 2mm' },
    // the solid line under the user block / previous section is drawn as the next title's top
    title: { ...emph, borderTop: line('0.5pt'), padding: '2.5mm 3mm 0.5mm' },
    item: { padding: '1.5mm 3mm 1.5mm 6mm' },
    last: { paddingBottom: '2.5mm' },
    dots: { borderTop: line('0.5pt', 'dotted'), margin: '0 3mm 0 6mm' },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr)) 24mm',
      columnGap: '5mm',
      alignItems: 'baseline',
    },
    job: { display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 88mm', columnGap: '5mm' },
    hours: { ...strong, fontSize: '10pt', gridArea: '1 / -2', textAlign: 'right' },
    fraction: { display: 'inline-block', width: '7.5mm', textAlign: 'left' },
    totalLabel: {
      gridArea: '1 / 3',
      justifySelf: 'end',
      fontSize: '9pt',
      fontWeight: 400,
      whiteSpace: 'nowrap',
    },
    info: { ...cell, gridColumn: 1 },
    fields: { display: 'flex', flexWrap: 'wrap', columnGap: '6mm' },
    group: { marginTop: '1.2mm' },
    time: { ...cell, gridColumn: '1 / -1', fontSize: '9pt' },
    timeRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) 24mm',
      columnGap: '3mm',
      alignItems: 'baseline',
    },
    beside: { gridColumn: 2, borderLeft: line('0.5pt'), paddingLeft: '3mm' },
    label: { whiteSpace: 'nowrap' },
    value: { fontWeight: 500 },
    nowrap: { whiteSpace: 'nowrap' },
    emph,
    jobName: { ...emph, gridColumn: '1 / -1', overflowWrap: 'anywhere' },
    summary: { fontSize: '9pt', whiteSpace: 'nowrap', borderTop: line('1pt'), padding: '2mm 3mm' },
    week: { borderTop: line('1.5pt'), padding: '2mm 2mm 0 0' },
    weekTitle: { fontSize: '12pt', fontWeight: 600 },
    weekSum: { ...sum, fontSize: '10.5pt' },
  };
};
